<template>
  <div class="nav-bar-container">
    <van-nav-bar
      :title="navTitle"
      fixed
      left-arrow
      class="nav-bar-custom"
      :border="false"
      placeholder
    >
      <template #left>
        <img
          src="@/assets/mobile/left-nav-icon.png"
          v-if="show"
          class="nav-icon"
          @click="show = false"
        />
        <img
          src="@/assets/mobile/left-nav-icon-show.png"
          v-if="!show"
          class="nav-icon"
          @click="show = true"
        />
        <img
          src="@/assets/mobile/nav-back.png"
          v-if="isBack"
          class="nav-icon icon-back"
          @click="$router.back()"
        />
      </template>
      <template #right>
        <img
          src="@/assets/mobile/right-nav-icon.png"
          class="nav-icon"
          @click="changeLanguage"
        />

        <div class="content-popover">
          <van-popover
            v-model="showPopover"
            :offset="offset"
            :get-container="getPopContainer"
            trigger="click"
            :actions="actions"
            placement="bottom-end"
            @select="handleSelect"
          >
            <template #reference> </template>
          </van-popover>
        </div>
      </template>
    </van-nav-bar>
    <div class="my-container" style="height: 100%;">
      <van-popup
        v-model="show"
        position="left"
        :style="{ height: '100%', width: '60%' }"
        overlay-class="custom-popup-overlay"
        :get-container="getContainer"
      >
        <div class="popup-container">
          <div class="logo">
            <img src="@/assets/img/logo.png" />
            <span>{{ $t('main.KubuqiOfficialWebsite') }}</span>
          </div>
          <div
            v-for="(item, index) in navbars"
            :key="index"
            @click="handleClick(item)"
            :class="[fullPath.includes(item.path) ? 'active-nav-bar' : '']"
            class="item-nav-bar"
          >
            <span>
              {{ item.name }}
            </span>
          </div>
          <div class="login">
            <div class="login-btn" @click="handleLogin">
              {{
                cookie ? $t('main.logOut') : $t('main.loginAndRegistration1')
              }}
            </div>
          </div>
          <div class="flex justify-center items-center code-container">
            <img
              src="https://gp-hk-dev.oss-cn-hongkong.aliyuncs.com/kubuqi/kubuqiAwardsQrCode.png"
              alt=""
              srcset=""
              class="wp-35"
            />
            <div class="pl-p-2">
              <div class="font-bold">{{ $t('main.sliderTitle') }}</div>
              <div>{{ $t('main.sliderSubtitle') }}</div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import { getCookie } from 'utils/cookie'
import { removeCookie } from 'utils/cookie'
import { Dialog } from 'vant'
export default {
  name: 'KubuqiGameNavBar',
  props: {
    title: {
      type: String,
      default: ''
    },
    isBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      showPopover: false,
      offset: [15, 10],
      cookie: '',
      actions: [
        {
          text: '繁體中文',
          value: 'zhComplex',
          type: 'zh-hk'
        },
        {
          text: '简体中文',
          value: 'zhSimple',
          type: 'zh-cn'
        },
        {
          text: 'English',
          value: 'en-us'
        }
      ],
      navbars: [
        {
          name: this.$t('main.homePage'),
          path: '/mobile/home'
        },
        {
          name: this.$t('main.backgroundOfTheCompetition'),
          path: '/mobile/great/contest'
        },
        {
          name: this.$t('main.latestNews'),
          path: '/mobile/news/consult'
          // path: '/mobile/news/consult/detail'
        },
        {
          name: this.$t('main.secondTitle'),
          path: '/mobile/prize/winner/index'
        },
        {
          name: this.$t('main.pastGames'),
          path: '/mobile/past/games/index'
        },
        {
          name: this.$t('main.commonProblem'),
          path: '/mobile/familiarProblem/index'
        },
        {
          name: this.$t('main.aboutUs'),
          path: '/mobile/about-us/index'
          // path: '/mobile/login'
        },
        {
          name: this.$t('main.findUs'),
          path: '/mobile/contact-us/index'
          // path: '/mobile/personal-centered/index'
        }
      ]
      // title: this.$t("main.homePage")
    }
  },
  computed: {
    navTitle() {
      // const path = this.$route.fullPath
      // const title = this.navbars.find(item => item.path === path)?.name
      return this.title
    },
    fullPath() {
      return this.$route.fullPath
    }
  },
  mounted() {
    this.cookie = getCookie('token') || ''
    if (this.cookie) {
      const obj = {
        name: this.$t('main.personalCenter'),
        path: '/mobile/personal-centered/index'
      }
      this.navbars.push(obj)
    }
  },

  methods: {
    getContainer() {
      return document.querySelector('.my-container')
    },
    handleClick(item) {
      this.show = false
      this.$router.push(item.path)
    },
    getPopContainer() {
      return document.querySelector('.content-popover')
    },
    changeLanguage() {
      this.showPopover = true
      this.show = false
    },
    handleSelect(item, index) {
      this.$i18n.locale = item.value
      localStorage.setItem('lang', item.value)
      localStorage.setItem('language', item.type)
      location.reload()
    },
    handleLogin() {
      if (this.cookie) {
        Dialog.confirm({
          title: '提示',
          message: '您确认要退出登录吗？'
        })
          .then(() => {
            removeCookie('token')
            this.$store.dispatch('user/resetUserInfo')
            this.$router.push({ path: '/mobile/logIn' })
          })
          .catch(() => {})
      } else {
        this.$router.push({ path: '/mobile/login' })
        this.show = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.nav-bar-container {
  position: relative;
  z-index: 999;
}
.nav-bar-custom {
  z-index: 999;
  position: relative;

  ::v-deep .van-nav-bar {
    background: #000000;
  }

  ::v-deep .van-nav-bar__title {
    color: #fff;
  }

  .nav-icon {
    width: 22px;
    height: 22px;
  }
  .icon-back {
    margin-left: 10px;
  }
}

::v-deep .custom-popup-overlay {
  background-color: rgba(0, 0, 0, 0.4) !important;
}

.my-container {
  position: relative;
  z-index: 998;

  .popup-container {
    margin-top: 50px;

    .logo {
      display: flex;
      align-items: center;
      padding-left: 24px;
      padding-top: 24px;

      img {
        width: 55px;
        height: 48px;
      }

      span {
        font-weight: bold;
        padding-left: 16px;
        font-size: 1.4rem;
      }
    }

    .item-nav-bar {
      padding: 16px 0;
      font-size: 1rem;

      span {
        padding-left: 24px;
      }
    }

    .active-nav-bar {
      background: rgba(244, 245, 245, 0.45);
      display: flex;
      align-items: center;

      &::before {
        content: '';
        display: block;
        width: 4px;
        height: 28px;
        background: #2c8779;
        border-radius: 2px;
      }
    }

    .login {
      border-top: 1px solid #e5e5e5;
      padding: 40px 20px 16px 24px;
      margin-top: 1.2rem;

      .login-btn {
        min-width: 70%;
        width: fit-content;
        padding: 0 10px;
        height: 2.6rem;
        border-radius: 3px;
        border: 1px solid #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.2rem;
        color: #333333;
      }
    }

    .code-container {
      padding-left: 12px;
      padding-top: 35px;
      padding-bottom: 40px;
    }
  }
}
</style>
